import CirgsNewCustomer from './CirgsNewCustomer';

export default CirgsNewCustomer;
